import {ActiveUserAddress} from '@domain/model/Account/UserAddress/ActiveUserAddress';
import {ViewActiveUserAddressByUserIdQuery} from '@domain/model/Account/UserAddress/ViewActiveUserAddressByUserIdQuery';

type ActiveUserAddressRepository = {
  viewActiveUserAddressByUserId(query: ViewActiveUserAddressByUserIdQuery): Promise<ActiveUserAddress | null>;
};

const ViewActiveUserAddressByUserId =
  (repository: ActiveUserAddressRepository) =>
  (query: ViewActiveUserAddressByUserIdQuery): Promise<ActiveUserAddress | null> => {
    if (!query?.userId) {
      return Promise.resolve(null);
    }

    return repository.viewActiveUserAddressByUserId(query);
  };

export {ViewActiveUserAddressByUserId};
